export default __webpack_public_path__ + "static/media/more-black.761b0e84.svg";